import { FunctionComponent, useState } from "react";
import { FormInstance } from "antd";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Eye, EyeOff, Zap, Shield, Lock, User } from "lucide-react";

interface UserFormProps {
  formRef: FormInstance<any>;
  handleClick: (values: any) => void;
  errorMsg: string | null;
}

const UserForm: FunctionComponent<UserFormProps> = ({
/*   formRef, */
  handleClick,
  errorMsg,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordRepeat, setShowPasswordRepeat] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    passwordRepeat: ''
  });

  const onFinish = (e: React.FormEvent) => {
    e.preventDefault();
    handleClick(formData);
  };

  const handleInputChange = (field: string, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

/*   const validatePassword = (password: string, passwordRepeat: string) => {
    if (password === passwordRepeat) {
      return true;
    }
    return false;
  }; */

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-white/90 mb-2">
        Fyll i dina uppgifter för att komma igång

        </h2>
        <p className="text-white/70 text-sm">
        </p>
      </div>

      {errorMsg && (
        <div className="rounded-xl border border-[rgba(255,107,107,0.3)] bg-[rgba(255,107,107,0.1)] p-4">
          <div className="text-[#ff6b6b] font-semibold text-sm">
            {errorMsg}
          </div>
        </div>
      )}

      <form onSubmit={onFinish} className="space-y-6">
        <div className="space-y-2">
          <Label htmlFor="name" className="text-white/80 text-sm font-medium">
            Namn
          </Label>
          <div className="relative">
            <User className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-[#a8b8ff]" />
            <Input
              id="name"
              type="text"
              value={formData.name}
              onChange={(e) => handleInputChange('name', e.target.value)}
              placeholder="Ditt namn"
              autoComplete="name"
              className="pl-10 bg-white/90 border-white/20 rounded-xl text-gray-900 h-12 text-base transition-all duration-300 hover:bg-white hover:border-[rgba(120,119,198,0.6)] hover:shadow-[0_0_0_3px_rgba(120,119,198,0.1)] focus:bg-white focus:border-[rgba(120,119,198,0.6)] focus:shadow-[0_0_0_3px_rgba(120,119,198,0.1)] placeholder:text-gray-500"
              required
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="email" className="text-white/80 text-sm font-medium">
            E-postadress
          </Label>
          <div className="relative">
            <Zap className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-[#a8b8ff]" />
            <Input
              id="email"
              type="email"
              value={formData.email}
              onChange={(e) => handleInputChange('email', e.target.value)}
              placeholder="namn@dittföretag.se"
              autoComplete="username"
              className="pl-10 bg-white/90 border-white/20 rounded-xl text-gray-900 h-12 text-base transition-all duration-300 hover:bg-white hover:border-[rgba(120,119,198,0.6)] hover:shadow-[0_0_0_3px_rgba(120,119,198,0.1)] focus:bg-white focus:border-[rgba(120,119,198,0.6)] focus:shadow-[0_0_0_3px_rgba(120,119,198,0.1)] placeholder:text-gray-500"
              required
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="password" className="text-white/80 text-sm font-medium">
            Lösenord
          </Label>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-[#a8b8ff]" />
            <Input
              id="password"
              type={showPassword ? "text" : "password"}
              value={formData.password}
              onChange={(e) => handleInputChange('password', e.target.value)}
              placeholder="********"
              autoComplete="new-password"
              className="pl-10 pr-12 bg-white/90 border-white/20 rounded-xl text-gray-900 h-12 text-base transition-all duration-300 hover:bg-white hover:border-[rgba(120,119,198,0.6)] hover:shadow-[0_0_0_3px_rgba(120,119,198,0.1)] focus:bg-white focus:border-[rgba(120,119,198,0.6)] focus:shadow-[0_0_0_3px_rgba(120,119,198,0.1)] placeholder:text-gray-500"
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 p-1 rounded transition-all duration-200"
            >
              {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="passwordRepeat" className="text-white/80 text-sm font-medium">
            Upprepa lösenord
          </Label>
          <div className="relative">
            <Shield className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-[#a8b8ff]" />
            <Input
              id="passwordRepeat"
              type={showPasswordRepeat ? "text" : "password"}
              value={formData.passwordRepeat}
              onChange={(e) => handleInputChange('passwordRepeat', e.target.value)}
              placeholder="********"
              autoComplete="new-password"
              className="pl-10 pr-12 bg-white/90 border-white/20 rounded-xl text-gray-900 h-12 text-base transition-all duration-300 hover:bg-white hover:border-[rgba(120,119,198,0.6)] hover:shadow-[0_0_0_3px_rgba(120,119,198,0.1)] focus:bg-white focus:border-[rgba(120,119,198,0.6)] focus:shadow-[0_0_0_3px_rgba(120,119,198,0.1)] placeholder:text-gray-500"
              required
            />
            <button
              type="button"
              onClick={() => setShowPasswordRepeat(!showPasswordRepeat)}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 p-1 rounded transition-all duration-200"
            >
              {showPasswordRepeat ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </div>
        </div>

        <Button
          type="submit"
          className="w-full bg-gradient-to-r from-[#667eea] to-[#764ba2] hover:from-[#5a6fd8] hover:to-[#6a4190] border-none rounded-xl h-12 text-base font-semibold transition-all duration-300 hover:transform hover:-translate-y-0.5 hover:shadow-[0_10px_25px_rgba(102,126,234,0.3)] active:transform-none flex items-center justify-center gap-2"
        >
          Skapa konto
        </Button>
      </form>

      <div className="text-center text-white/60 text-xs">
        Genom att fortsätta med registreringen godkänner du våra{" "}
        <a href="https://graftus.ai/villkor-foretag/" target="_blank" className="text-[#a8b8ff] hover:underline">
          villkor
        </a>{" "}
        och vår{" "}
        <a href="https://graftus.ai/integritetspolicy/" target="_blank" className="text-[#a8b8ff] hover:underline">
          integritetspolicy
        </a>
      </div>
    </div>
  );
};

export default UserForm;
